import "./index.scss";
import { CfFooterSchema } from "./schema";
import { CfIconNames } from "types/cf-utils/types";
import { Poly } from "components/Poly";
import { PolyAnchor } from "components/Anchor/utils";
import IconDynamic from "components/Icon/IconDynamic";
import React from "react";

type LinkColumn = { title: string; list: ({ label: string } & PolyAnchor)[] };

export type Props = {
  apps: CfFooterSchema["dataJson"]["top"]["left"]["apps"];
  center: LinkColumn[];
  social: CfFooterSchema["dataJson"]["top"]["right"]["social"];
  logo: CfFooterSchema["dataJson"]["bottom"]["logo"];
  disclaimer: React.ReactNode;
  manageCookies: string;
  onManageCookiesClick: VoidFunction;
};

const FooterColumn = ({ title, list }: LinkColumn) => (
  <div>
    <p className="footer-new__center__title">{title}</p>
    <ul className="footer-new__center__column">
      {list.map(({ label, ...props }) => (
        <li key={label}>
          <Poly {...props}>{label}</Poly>
        </li>
      ))}
    </ul>
  </div>
);

const AppColumn = ({
  title,
  list,
}: CfFooterSchema["dataJson"]["top"]["left"]["apps"]) => (
  <>
    <p className="footer-new__left__title">{title}</p>
    <div className="footer-new__left__content">
      {list.map((app) => (
        <a key={app.alt} href={app.href}>
          <img width={48} height={48} src={app.image} alt={app.alt} />
        </a>
      ))}
    </div>
  </>
);

const SocialColumn = ({
  title,
  list,
}: CfFooterSchema["dataJson"]["top"]["right"]["social"]) => (
  <>
    <p className="footer-new__right__title">{title}</p>
    <div className="footer-new__right__content">
      {list.map(({ href, icon }) => (
        <a
          key={icon}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={icon}
        >
          <IconDynamic name={icon as CfIconNames} />
        </a>
      ))}
    </div>
  </>
);

const Footer = ({
  apps,
  center,
  social,
  logo,
  disclaimer,
  manageCookies,
  onManageCookiesClick,
}: Props) => (
  <footer className="footer-new__container">
    <div className="footer-new__left">
      <AppColumn {...apps} />
    </div>
    <div className="footer-new__center">
      {center.map((column) => (
        <FooterColumn key={column.title} {...column} />
      ))}
    </div>
    <div className="footer-new__right">
      <SocialColumn {...social} />
    </div>
    <div className="footer-new__divider" />
    <div className="footer-new__logo">
      <a href={logo.url}>
        <img src={logo.src} alt={logo.alt} />
      </a>
    </div>
    <div className="footer-new__disclaimer">{disclaimer}</div>
    <div className="footer-new__cookies">
      <button type="button" onClick={onManageCookiesClick}>
        {manageCookies}
      </button>
    </div>
  </footer>
);

Footer.displayName = "Footer";

export default Footer;
